export enum Currency {
    UNKNOWN = 0,
    RUB = 1,
    USD = 2,
    EUR = 3
}
